<h1 mat-dialog-title>{{ review ? 'Review your imported rooms' : 'Import the rooms you\'ve played' }}</h1>
<mat-dialog-content>
  <ng-container *ngIf="!review">
    <p class="intro">
      We'll look up the finalists you've logged on your tracking site. You'll see what we found and choose what to add.
    </p>
    <div class="flex-row flex-wrap align-start gap-10 fields">
      <mat-form-field class="site-field" subscriptSizing="dynamic">
        <mat-label>Tracking site</mat-label>
        <mat-select [formControl]="siteControl">
          <mat-option *ngFor="let option of options" [value]="option" [disabled]="!canImport(option)">
            {{ option.label }}<ng-container *ngIf="option.status === 'coming'"> (coming soon)</ng-container>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="site" class="id-field" subscriptSizing="dynamic">
        <mat-label>{{ partner ? 'Your ' + site.label + ' id' : 'Test id' }}</mat-label>
        <input matInput [formControl]="idControl" (keyup.enter)="importRooms()">
        <mat-hint *ngIf="partner">{{ partner.idHint }}</mat-hint>
        <mat-error *ngIf="idControl.hasError('pattern')">That doesn't look like a {{ site.label }} id</mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="loading" class="flex-row align-center gap-10">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Asking {{ site?.label }} for your rooms…</span>
    </div>
    <div *ngIf="error" class="problem">{{ error }}</div>
    <ng-container *ngIf="result as r" [ngSwitch]="r.outcome">
      <div *ngSwitchCase="'noId'" class="problem">Enter your id to import.</div>
      <div *ngSwitchCase="'notFound'" class="problem">
        {{ site?.label }} doesn't recognize the id <b>{{ r.userid }}</b>. Check it and try again.
      </div>
      <div *ngSwitchCase="'private'" class="problem">
        Your {{ site?.label }} profile is private, so it can't share your rooms. Make it public, import again, and then
        you can make it private again.
      </div>
      <div *ngSwitchCase="'empty'" class="problem">
        {{ site?.label }} has no rooms we list for <b>{{ r.partnerUserName || r.userid }}</b>.
      </div>
      <div *ngSwitchCase="'notReady'" class="problem">
        {{ site?.label }} isn't ready for this year's rooms yet. Please check back in a few days.
      </div>
      <div *ngSwitchCase="'unavailable'" class="problem">
        {{ site?.label }} didn't answer. Please try again later.
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="review as r">
    <p class="found">
      {{ site?.label }} found {{ result?.rooms?.length }} room{{ result?.rooms?.length === 1 ? '' : 's' }}
      <ng-container *ngIf="result?.partnerUserName"> for <b>{{ result?.partnerUserName }}</b></ng-container>.
      <span class="secondary">If that isn't you, go back and check your id.</span>
    </p>
    <p *ngIf="!hasRoomsToReview()">
      None of them are finalists you haven't already selected.
    </p>

    <ng-container *ngIf="r.played.length">
      <h3>Rooms you played</h3>
      <div *ngFor="let entry of r.played" class="flex-row align-center gap-5">
        <mat-checkbox [checked]="entry.checked" (change)="entry.checked = $event.checked" color="primary"></mat-checkbox>
        <app-simpleroom [room]="entry.room"></app-simpleroom>
      </div>
    </ng-container>

    <ng-container *ngIf="r.maybeGroups.length">
      <h3>Rooms you may have played</h3>
      <div *ngFor="let group of r.maybeGroups" class="maybe-group">
        <p [innerHTML]="group.reason"></p>
        <div *ngFor="let entry of group.rooms" class="flex-row align-center gap-5">
          <mat-checkbox [checked]="entry.checked" (change)="entry.checked = $event.checked" color="primary"></mat-checkbox>
          <app-simpleroom [room]="entry.room"></app-simpleroom>
        </div>
      </div>
    </ng-container>

    <div class="notes secondary">
      <div *ngIf="r.alreadyMarked.length">
        {{ r.alreadyMarked.length }} room{{ r.alreadyMarked.length === 1 ? ' is' : 's are' }} already selected.
      </div>
      <div *ngIf="r.affiliated.length">
        Left out {{ r.affiliated.length }} room{{ r.affiliated.length === 1 ? '' : 's' }} you're affiliated with.
      </div>
      <div *ngIf="r.notOnBallot">
        {{ r.notOnBallot }} other room{{ r.notOnBallot === 1 ? ' isn\'t a finalist' : 's aren\'t finalists' }} this year.
      </div>
    </div>
    <p class="secondary">To import from another site or try again, hit Back.</p>
  </ng-container>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <ng-container *ngIf="!review">
    <button mat-raised-button color="secondary" (click)="close()" [disabled]="loading">Cancel</button>
    <button mat-raised-button color="primary" (click)="importRooms()" [disabled]="loading || !canImport(site)">Import</button>
  </ng-container>
  <ng-container *ngIf="review">
    <button mat-raised-button color="secondary" (click)="leaveReview(false)" [disabled]="adding">Back</button>
    <button mat-raised-button color="primary" (click)="addChecked()" [disabled]="adding || !checkedCount()">
      Add {{ checkedCount() }} room{{ checkedCount() === 1 ? '' : 's' }}
    </button>
  </ng-container>
</div>
